import { provideTranslateService } from "@ngx-translate/core";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";

export const DEFAULT_LOCALE = new Intl.Locale("fr-FR");

export const provideI18n = () =>
  provideTranslateService({
    loader: provideTranslateHttpLoader({
      prefix: "/i18n/",
      suffix: ".json",
      useHttpBackend: true, // Skip Angular Http Interceptors
      // A changing parameter: the server sets no cache header for this file, and a hard reload does not empty what
      // a script asks for. Without it a text changed in the root file (menu, breadcrumb) stayed the old one.
      enforceLoading: true,
    }),
    fallbackLang: DEFAULT_LOCALE.language,
    extend: true,
  });
